import React from 'react';
import PropTypes from 'prop-types';

import classes from './FileIcon.scss';

class FileIcon extends React.Component {
  render() {
    const bigClass = this.props.big ? classes.big : '';

    return (
      <span
        className={`${classes.fileIcon} file-icon extension-${this.props.extension} ${bigClass}`}
        data-extension={this.props.extension}
      >
        <span className={classes.fileCorner} />
      </span>
    );
  }
}

FileIcon.propTypes = {
  extension: PropTypes.string.isRequired,
  big: PropTypes.bool,
};

FileIcon.defaultProps = {
  big: false,
};

export default FileIcon;



// WEBPACK FOOTER //
// ./src/components/FileIcon/FileIcon.js